{
  "familyId": "SPR-KLANK-AA-EE-OO",
  "questions": [
    {
      "id": "SPR-KLANK-AA-EE-OO-001",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft in zijn werkstuk: 'De maanen schijnen helder.' De juf streept een woord aan. Welke verbetering is correct?",
      "context": "De leerling twijfelt over de spelling van het meervoud van 'maan'.",
      "options": ["manen", "maanen", "maannen", "mannen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "syllableBlocks", "data": {"word": "manen", "syllables": ["ma", "nen"], "types": ["open", "closed"], "label": "Open lettergreep"}, "showWhen": "wrong"}, {"type": "rule", "data": {"title": "Lange klinker in open lettergreep", "content": "In een open lettergreep (eindigt op klinker) schrijf je de lange klank met één letter: ma-nen (niet maa-nen). De 'aa' wordt 'a' omdat de lettergreep al open is.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_aa",
      "variantIndex": 1,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SPR-DUBBEL-KLINKER-OPEN", "optionIndex": 1, "label": "Denkt dat dubbele klinker nodig is in open lettergreep" },
          { "id": "SPR-DUBBEL-KLINKER-EN-MEDEKLINKER", "optionIndex": 2, "label": "Verdubbelt zowel klinker als medeklinker" },
          { "id": "SPR-MAAN-MAN-VERWARD", "optionIndex": 3, "label": "Verwart meervoud van 'maan' met 'man' (bakker-regel)" }
        ]
      },
      "feedback": {
        "explanationText": "De leerling schreef 'maanen', maar dat is fout. Verdeel in lettergrepen: ma-nen. De lettergreep 'ma-' is open (eindigt op een klinker). In een open lettergreep schrijf je de lange klank met één letter: 'ma'. Dus: ma-nen, niet maa-nen. De juf verbetert het naar 'manen'.",
        "solutionSteps": [
          "Herken de fout: 'maanen' heeft dubbele 'aa' — klopt dat?",
          "Verdeel in lettergrepen: ma-nen",
          "De lettergreep 'ma-' eindigt op een klinker → open lettergreep",
          "Open lettergreep → lange klank met één letter: manen ✓"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Manen' is juist: de open lettergreep 'ma-' maakt de 'a' al lang, dus je schrijft maar één 'a'.",
          "1": "Je dacht waarschijnlijk dat de dubbele 'aa' nodig is voor de lange klank. Maar in een open lettergreep (ma-nen) is de klank al lang door de open lettergreep. Je hoeft de 'a' niet te verdubbelen. Onthoud: open lettergreep = één klinker.",
          "2": "Je dacht waarschijnlijk dat je de dubbele 'aa' houdt én de medeklinker verdubbelt. Maar in een open lettergreep (ma-nen) is de klank al lang door de open lettergreep. Je schrijft maar één 'a' en één 'n'. Onthoud: open lettergreep = één klinker.",
          "3": "Je dacht waarschijnlijk dat het meervoud van 'maan' hetzelfde is als van 'man'. Maar 'mannen' is het meervoud van 'man' (korte 'a', bakker-regel). Het meervoud van 'maan' (lange 'aa') is 'manen' (jager-regel). Onthoud: maan → manen, man → mannen."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-002",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "De meester schrijft vier woorden op het bord. Eén woord is fout gespeld. Welk woord moet verbeterd worden?",
      "context": "Op het bord staat: bomen, stoelen, boomen, ramen",
      "options": ["bomen → moet boomen zijn", "stoelen → moet stoelen zijn", "boomen → moet bomen zijn", "ramen → moet raamen zijn"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [{"type": "syllableBlocks", "data": {"word": "bomen", "syllables": ["bo", "men"], "types": ["open", "closed"], "label": "Open lettergreep"}, "showWhen": "wrong"}, {"type": "rule", "data": {"title": "Lange klinker: oo → o", "content": "boom → bo-men: de lettergreep 'bo-' is open. In een open lettergreep schrijf je de lange 'oo' als één 'o'. Dus: bo-men, niet boo-men.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_oo",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SPR-BOMEN-FOUT-GEDACHT", "optionIndex": 0, "label": "Denkt dat correct gespeld 'bomen' fout is" },
          { "id": "SPR-TWEEKLANK-VERWARD", "optionIndex": 1, "label": "Verwart tweeklank 'oe' met lange klinker 'oo'" },
          { "id": "SPR-RAMEN-DUBBEL", "optionIndex": 3, "label": "Denkt dat 'ramen' dubbele 'aa' nodig heeft" }
        ]
      },
      "feedback": {
        "explanationText": "Het woord 'boomen' is fout. Verdeel in lettergrepen: bo-men. De lettergreep 'bo-' is open (eindigt op een klinker). In een open lettergreep schrijf je de lange 'oo' als één 'o'. Dus: bo-men, niet boo-men. De andere woorden (bomen, stoelen, ramen) zijn allemaal correct gespeld.",
        "solutionSteps": [
          "Controleer elk woord: bomen, stoelen, boomen, ramen",
          "Herken de fout: 'boomen' heeft dubbele 'oo' in het meervoud",
          "Verdeel: bo-men — open lettergreep 'bo-'",
          "Open lettergreep → één klinker: bomen ✓, niet boomen ✗"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'bomen' fout is en twee o's nodig heeft. Maar 'bomen' is juist: de open lettergreep 'bo-' maakt de 'o' al lang. Onthoud: open lettergreep = één klinker.",
          "1": "Je dacht waarschijnlijk dat 'stoelen' fout is. Maar 'stoelen' is correct: stoe-len. De 'oe' is een tweeklank (geen lange 'o') en verandert niet in het meervoud.",
          "2": "Correct! 'Boomen' is fout en moet 'bomen' zijn. Open lettergreep 'bo-' → één 'o'.",
          "3": "Je dacht waarschijnlijk dat 'ramen' twee a's nodig heeft. Maar 'ramen' is correct: ra-men. De open lettergreep 'ra-' maakt de 'a' al lang. Onthoud: raam → ramen (open lettergreep = één klinker)."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-003",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Een leerling maakt een dictee. De juf zegt: 'De dokter onderzoekt je benen.' De leerling twijfelt. Welke spelling is correct?",
      "context": "Het gaat om het meervoud van 'been' (= lichaamsdeel).",
      "options": ["beenen", "benen", "beennen", "bennen"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Lange klinker: ee → e", "content": "been → be-nen: de lettergreep 'be-' is open. In een open lettergreep schrijf je de lange 'ee' als één 'e'. Dus: be-nen, niet bee-nen.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_ee",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SPR-DUBBEL-EE-OPEN", "optionIndex": 0, "label": "Denkt dat dubbele 'ee' nodig is in open lettergreep" },
          { "id": "SPR-DUBBEL-KLINKER-EN-MEDEKLINKER-EE", "optionIndex": 2, "label": "Verdubbelt zowel 'ee' als 'n'" },
          { "id": "SPR-BAKKER-JAGER-VERWARD", "optionIndex": 3, "label": "Verwart bakker-regel (korte klank) met jager-regel (lange klank)" }
        ]
      },
      "feedback": {
        "explanationText": "De leerling moet 'benen' schrijven. Verdeel in lettergrepen: be-nen. De lettergreep 'be-' is open (eindigt op een klinker). In een open lettergreep schrijf je de lange 'ee' als één 'e'. Dus: be-nen, niet bee-nen. De juf-regel: open lettergreep = één klinker.",
        "solutionSteps": [
          "Herken: het meervoud van 'been' — hoe schrijf je dat?",
          "Verdeel in lettergrepen: be-nen",
          "De lettergreep 'be-' eindigt op een klinker → open lettergreep",
          "Open lettergreep → lange klank met één letter: benen ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de dubbele 'ee' nodig is. Maar in een open lettergreep (be-nen) is de klank al lang. Je hoeft de 'e' niet te verdubbelen. Onthoud: been → benen, net als maan → manen.",
          "1": "Correct! 'Benen' is juist: de open lettergreep 'be-' maakt de 'e' al lang, dus je schrijft maar één 'e'.",
          "2": "Je dacht waarschijnlijk dat je de dubbele 'ee' houdt én de medeklinker verdubbelt. Maar in een open lettergreep (be-nen) is de klank al lang. Je schrijft maar één 'e' en één 'n'. Onthoud: open lettergreep = één klinker.",
          "3": "Je dacht waarschijnlijk dat de medeklinker verdubbeld moet worden. Maar 'bennen' zou een korte 'e' geven (bakker-regel). Bij 'benen' klinkt de 'e' lang → jager-regel: be-nen. Onthoud: lange klank = enkele medeklinker."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-004",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft drie zinnen. In welke zin zit een spellingfout met een lange klinker?",
      "context": null,
      "options": [
        "'De bomen in het bos zijn heel groot.' (alles klopt)",
        "'De bomen in het boos zijn heel groot.' (boos is fout)",
        "'De bomen in het bos zijn heel grroot.' (grroot is fout)",
        "'De boomen in het bos zijn heel groot.' (boomen is fout)"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Lange klinker in open lettergreep", "content": "boom → bo-men (open lettergreep: één 'o')\nbos → bos (gesloten lettergreep: korte 'o', blijft 'o')\ngroot → groot (gesloten lettergreep: lange 'oo' blijft 'oo')", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_zin_correct",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SPR-CORRECT-ALS-FOUT", "optionIndex": 0, "label": "Denkt dat correct 'bomen' fout is" },
          { "id": "SPR-BETEKENIS-VS-SPELLING", "optionIndex": 1, "label": "Verwart betekenisfout met spellingfout" },
          { "id": "SPR-MEDEKLINKER-FOCUS", "optionIndex": 2, "label": "Focust op medeklinkers i.p.v. klinkers" }
        ]
      },
      "feedback": {
        "explanationText": "De fout zit in 'boomen'. Verdeel: bo-men — de open lettergreep 'bo-' maakt de 'o' al lang, dus je schrijft maar één 'o'. De andere woorden zijn correct: 'bos' (gesloten lettergreep, korte 'o'), 'groot' (gesloten lettergreep, lange 'oo' blijft 'oo').",
        "solutionSteps": [
          "Zoek de fout: controleer elk woord met een lange klinker",
          "'boomen': bo-men — open lettergreep → één 'o' nodig → FOUT",
          "'bos': gesloten lettergreep, korte 'o' → correct",
          "'groot': gesloten lettergreep, lange 'oo' → correct (blijft 'oo')"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de zin met 'bomen' helemaal klopt. Dat klopt ook! Maar de vraag is welke zin een fout bevat — en dat is de zin met 'boomen'. Lees de vraag goed: je zoekt de fout.",
          "1": "Je dacht waarschijnlijk dat 'boos' fout is in deze zin. Maar 'boos' is een bestaand woord (= kwaad). De zin 'in het boos' klopt niet qua betekenis, maar de spellingfout met een lange klinker zit in 'boomen'.",
          "2": "Je dacht waarschijnlijk dat 'grroot' de fout is. Maar 'grroot' bestaat niet als echte spellingfout — niemand schrijft twee r's. De echte fout is 'boomen' → 'bomen'. Onthoud: focus op de klinkerregel.",
          "3": "Correct! 'Boomen' is fout — het moet 'bomen' zijn. Open lettergreep 'bo-' → één 'o'."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-005",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "De juf legt de spellingregel uit. Welke uitleg past bij de woorden 'manen', 'bomen' en 'benen'?",
      "context": null,
      "options": [
        "In een open lettergreep schrijf je altijd twee klinkers naast elkaar.",
        "Lange klinkers schrijf je altijd dubbel (aa, ee, oo).",
        "In een open lettergreep schrijf je een lange klinker met één letter (aa→a, ee→e, oo→o).",
        "In een gesloten lettergreep schrijf je een lange klinker met één letter."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "De regel samengevat", "content": "Open lettergreep (eindigt op klinker) → lange klank met één letter: ma-nen, bo-men, be-nen\nGesloten lettergreep (eindigt op medeklinker) → lange klank met twee letters: maan, boom, been", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_regel_samenvatting",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SPR-OPEN-DUBBEL-VERWARD", "optionIndex": 0, "label": "Denkt dat open lettergreep twee klinkers vereist" },
          { "id": "SPR-ALTIJD-DUBBEL", "optionIndex": 1, "label": "Denkt dat lange klinkers altijd dubbel geschreven worden" },
          { "id": "SPR-OPEN-GESLOTEN-OMGEDRAAID", "optionIndex": 3, "label": "Verwisselt de regels voor open en gesloten lettergrepen" }
        ]
      },
      "feedback": {
        "explanationText": "De juf legt uit: in een OPEN lettergreep (eindigt op klinker) schrijf je de lange klank met één letter. Voorbeelden: maan → ma-nen, boom → bo-men, been → be-nen. In een GESLOTEN lettergreep (eindigt op medeklinker) schrijf je de lange klank met twee letters: maan, boom, been. De leerling moet de regel toepassen op nieuwe woorden.",
        "solutionSteps": [
          "Bekijk de voorbeelden: manen, bomen, benen — wat hebben ze gemeen?",
          "Alle drie hebben een open lettergreep: ma-, bo-, be-",
          "In een open lettergreep schrijf je de lange klank met één letter",
          "De regel: open lettergreep → aa wordt a, ee wordt e, oo wordt o"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je in een open lettergreep twee klinkers schrijft. Maar het is precies andersom: in een open lettergreep is de klank al lang, dus je schrijft maar één klinker. Twee klinkers (aa, ee, oo) gebruik je in een gesloten lettergreep.",
          "1": "Je dacht waarschijnlijk dat lange klinkers altijd dubbel zijn. Maar dat geldt alleen voor gesloten lettergrepen (maan, boom, been). In open lettergrepen schrijf je ze enkel (ma-nen, bo-men, be-nen). Onthoud: het hangt af van het type lettergreep.",
          "2": "Correct! In een open lettergreep schrijf je de lange klank met één letter: ma-nen, bo-men, be-nen.",
          "3": "Je verwisselt open en gesloten lettergrepen. In een GESLOTEN lettergreep schrijf je de lange klank met twee letters (maan, boom). In een OPEN lettergreep schrijf je de lange klank met één letter (ma-nen, bo-men)."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-006",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "categorize",
      "question": "Sorteer deze meervoudsvormen: welke zijn GOED en welke zijn FOUT gespeld?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Goed gespeld", "Fout gespeld"],
        "items": [
          { "text": "manen", "correctCategory": 0 },
          { "text": "boomen", "correctCategory": 1 },
          { "text": "benen", "correctCategory": 0 },
          { "text": "beenen", "correctCategory": 1 },
          { "text": "ramen", "correctCategory": 0 },
          { "text": "deeken", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Open lettergreep = één klinker", "content": "In een open lettergreep schrijf je de lange klank met één letter:\nmaan → ma-nen ✓ (niet maa-nen)\nboom → bo-men ✓ (niet boo-men)\nbeen → be-nen ✓ (niet bee-nen)\nraam → ra-men ✓ (niet raa-men)\ndeken → de-ken ✓ (niet dee-ken)", "icon": "book" } }
      ],
      "conceptId": "lange_klinker_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In een open lettergreep schrijf je de lange klank met één letter. Goed: manen (ma-nen), benen (be-nen), ramen (ra-men). Fout: boomen (moet bomen zijn), beenen (moet benen zijn), deeken (moet deken zijn). De open lettergreep maakt de klank al lang — je hoeft de klinker niet te verdubbelen.",
        "solutionSteps": [
          "Verdeel elk woord in lettergrepen",
          "Open lettergreep → één klinker volstaat",
          "Goed: manen, benen, ramen (één klinker in open lettergreep)",
          "Fout: boomen, beenen, deeken (dubbele klinker is overbodig)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-007",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "error_spotting",
      "question": "Zoek de spelfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "In de dierentuin zagen we aapen, leeuwen en grote vooten. De beeren sliepen in hun hol.",
        "errors": [
          {
            "word": "aapen",
            "position": 5,
            "correction": "apen",
            "explanation": "Aap → a-pen: open lettergreep, dus één 'a'. Niet 'aa-pen'."
          },
          {
            "word": "vooten",
            "position": 10,
            "correction": "voeten",
            "explanation": "Voet → voe-ten: 'oe' is een tweeklank en verandert niet. 'Vooten' bestaat niet."
          },
          {
            "word": "beeren",
            "position": 12,
            "correction": "beren",
            "explanation": "Beer → be-ren: open lettergreep, dus één 'e'. Niet 'bee-ren'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Lange klinker in open lettergreep", "content": "In een open lettergreep schrijf je de lange klank met één letter:\naap → a-pen (niet aa-pen)\nbeer → be-ren (niet bee-ren)\nLet op: 'leeuwen' is correct — 'eeuw' is een vaste lettercombinatie.", "icon": "book" } }
      ],
      "conceptId": "lange_klinker_error_spotting",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'aapen' moet 'apen' zijn (a-pen, open lettergreep), 'vooten' moet 'voeten' zijn ('oe' is een tweeklank, niet 'oo'), 'beeren' moet 'beren' zijn (be-ren, open lettergreep). 'Leeuwen' is correct — 'eeuw' is een vaste lettercombinatie.",
        "solutionSteps": [
          "Fout 1: aapen → apen (aap → a-pen, open lettergreep → één 'a')",
          "Fout 2: vooten → voeten ('oe' is een tweeklank, niet 'oo')",
          "Fout 3: beeren → beren (beer → be-ren, open lettergreep → één 'e')",
          "Correct: leeuwen ('eeuw' is een vaste lettercombinatie) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}